// extracted by mini-css-extract-plugin
export default {"main-grid":"bV5m60LLbbU_DpYq_uZr","main-content":"Y58XJPqkyQI6cBMWvZJG","listItem":"MrxTQ7uTP3id8pQ6hlMa"};